import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Card, Grid, Icon, Typography } from '@material-ui/core';
import InstagramIcon from '@material-ui/icons/Instagram';
import { Breadcrumb } from 'components';


export default function HomepageConfigurations() {
  const {profile, userStoreData} = useSelector((state) => state.user);
  const permissions = profile?.config?.permissions || {};
  const storeType = userStoreData?.storeType || null;
  const isPremiumPlus = storeType === 'premium_plus' || storeType === 'modern_premium_plus';
  const isPremium = storeType === 'premium' || storeType === 'modern_premium';
  const isModern = storeType === 'premium_lite';
  const isModernBased = storeType === 'premium_lite' || storeType === 'modern_premium' || storeType === 'modern_premium_plus';
  // const isRegular = storeType === 'regular';
  // const isSkinCeuticals = storeType === 'skinceuticals';
  // const isSite = storeType === 'custom';

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Settings', path: '/settings#go_live_requirements' },
            { name: 'UI Configurations', path: '/settings#UI_configurations' },
            { name: 'Homepage Settings'}
          ]}
        />
      </div>
      <div className="m-10">
        <Card className="p-8">
          <Typography variant="h4" className="mb-8">Homepage Settings</Typography>
          <Grid container spacing={3} className="text-center">
            {permissions?.homepageBanner &&
              <Grid item xs={12} sm={3} md={2} title="Click here to select homepage banner slides">
                <Link to="/homepage-banner">
                  <Card className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                    <Icon className="text-40" color="primary">ad_units</Icon>
                    <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Homepage Banner</Typography>
                  </Card>
                </Link>
              </Grid>
            }
            {permissions?.settingsHomepageWelcomeBlock && isPremium &&
              <Grid item xs={12} sm={3} md={2} title="Click here to select homepage banner slides">
                <Link to="/configurations/homepage/welcome-block">
                  <Card className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                    <Icon className="text-40" color="primary">grid_view</Icon>
                    <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Welcome Block</Typography>
                  </Card>
                </Link>
              </Grid>
            }
            {permissions?.settingsHomepageCTABlock && isPremium &&
              <Grid item xs={12} sm={3} md={2} title="Click here to add configurations for CTA">
                <Link to="/configurations/homepage/cta">
                  <Card className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                    <Icon className="text-40" color="primary">call_to_action</Icon>
                    <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Call To Actions</Typography>
                  </Card>
                </Link>
              </Grid>
            }
            {permissions?.settingsHomepageCTABlock && isModern &&
              <Grid item xs={12} sm={3} md={2} title="Click here to add configurations for CTA">
                <Link to="/configurations/homepage/modern-cta">
                  <Card className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                    <Icon className="text-40" color="primary">call_to_action</Icon>
                    <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Call To Actions</Typography>
                  </Card>
                </Link>
              </Grid>
            }
            {permissions?.settingsHomepagePromoTabs &&
            <Grid item xs={12} sm={3} md={2} title="Click here to select your bestsellers, this month’s specials, and new items you want to highlight on your store’s main page">
              <Link to="/configurations/promos">
                <Card className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                  <Icon className="text-40" color="primary">calendar_view_day</Icon>
                  <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">
                    Homepage {(isPremium || isPremiumPlus || isModern) ? 'Carousels' : 'Categories'}
                  </Typography>
                </Card>
              </Link>
            </Grid>
            }
            {permissions?.settingsHomepageRewardBlock && isPremium &&
            <Grid item xs={12} sm={3} md={2} title="Click here to update reward block">
              <Link to="/configurations/homepage/reward-block">
                <Card className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                  <Icon className="text-40" color="primary">star</Icon>
                  <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Reward Block</Typography>
                </Card>
              </Link>
            </Grid>
            }
            {permissions?.settingsHomepageInstagramBlock && (isPremium || isPremiumPlus) &&
            <Grid item xs={12} sm={3} md={2} title="Click here to edit instagram widger">
              <Link to="/configurations/homepage/instagram-widget">
                <Card className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                  <InstagramIcon className="text-40" color="primary" />
                  <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Instagram Widget</Typography>
                </Card>
              </Link>
            </Grid>
            }
            {permissions?.settingsAppointmentFormBlock && isPremium &&
            <Grid item xs={12} sm={3} md={2} title="Click here to edit instagram widger">
              <Link to="/configurations/homepage/appointment-form">
                <Card className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                  <Icon className="text-40" color="primary">event_note</Icon>
                  <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Appointment Form</Typography>
                </Card>
              </Link>
            </Grid>
            }
            {isPremiumPlus &&
              <Grid item xs={12} sm={3} md={2} title="Click here to select additional homepage banners slides">
                <Link to="/additional-homepage-banners">
                  <Card className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                    <Icon className="text-40" color="primary">ad_units</Icon>
                    <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Additional Homepage Banners</Typography>
                  </Card>
                </Link>
              </Grid>
            }
            {isPremiumPlus &&
              <Grid item xs={12} sm={3} md={2} title="Click here to add configurations for testimonials">
                <Link to="/configurations/homepage/testimonials">
                  <Card className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                    <Icon className="text-40" color="primary">reviews_icon</Icon>
                    <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Testimonials</Typography>
                  </Card>
                </Link>
              </Grid>
            }
            {isPremiumPlus &&
              <Grid item xs={12} sm={3} md={2} title="Click here to add configurations for additional header">
                <Link to="/configurations/homepage/additional-header">
                  <Card className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                    <Icon className="text-40" color="primary">padding_icon</Icon>
                    <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Additional Header</Typography>
                  </Card>
                </Link>
              </Grid>
            }
            {isPremiumPlus &&
              <Grid item xs={12} sm={3} md={2} title="Click here to add configurations for blog">
                <Link to="/configurations/homepage/blog">
                  <Card className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                    <Icon className="text-40" color="primary">book_icon</Icon>
                    <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Blog</Typography>
                  </Card>
                </Link>
              </Grid>
            }
            {isPremiumPlus &&
              <Grid item xs={12} sm={3} md={2} title="Click here to add configurations for premium CTA block">
                <Link to="/configurations/homepage/premium-cta">
                  <Card className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                    <Icon className="text-40" color="primary">view_compact_alt_icon</Icon>
                    <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Premium Call To Actions</Typography>
                  </Card>
                </Link>
              </Grid>
            }
            {isModernBased &&
              <Grid item xs={12} sm={3} md={2} title="Click here to update benefits block">
                <Link to="/configurations/homepage/benefits-block">
                  <Card className="py-8 light-blue-on-hover h-full flex-column justify-center items-center" elevation={8}>
                    <Icon className="text-40" color="primary">beenhere-icon</Icon>
                    <Typography variant="h5" className="mt-4 min-h-50 max-w-100" color="primary">Benefits Block</Typography>
                  </Card>
                </Link>
              </Grid>
            }
          </Grid>
        </Card>
      </div>
    </div>
  );
}
